import { render, staticRenderFns } from "./TimerLayer.vue?vue&type=template&id=1c58e5da"
import script from "./TimerLayer.vue?vue&type=script&lang=js"
export * from "./TimerLayer.vue?vue&type=script&lang=js"
import style0 from "./TimerLayer.vue?vue&type=style&index=0&id=1c58e5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports